import { render, staticRenderFns } from "./CreateWorker.vue?vue&type=template&id=53fd29d4"
import script from "./CreateWorker.vue?vue&type=script&lang=js"
export * from "./CreateWorker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports